import { Store } from 'pullstate'

const DCDashboardStore = new Store({ });

export default DCDashboardStore;